import {
  TextField,
  FormProvider,
  Flex,
  Heading,
  Text,
  Divider,
  Button,
} from '@agrotoken-tech/ui';
import { SectionGrid } from '../../SectionGrid';
import { FormStep } from './utils/form-step.interface';
import { useSecondStepForm } from './hooks/useSecondStepForm';
import { useTranslation } from '@bcba/react-hooks';

export const SecondStepForm = (props: FormStep) => {
  const { stepperJSX } = props;
  const { t } = useTranslation();
  const { handleSubmit, submitHandler, formMethods } = useSecondStepForm(props);

  return (
    <Flex
      w="full"
      px="48px"
      as="form"
      noValidate
      flexDir={'column'}
      onSubmit={handleSubmit(submitHandler)}
    >
      <Heading size="md" mb="12px">
        {t('businessSignUp.firstStep.title')}
      </Heading>

      {stepperJSX}
      <Text size="xl" variant="medium" mt="36px" mb="12px">
        {t('businessSignUp.secondStep.stepIndicator')}
      </Text>
      <Text mb="12px">{t('businessSignUp.secondStep.subtitle')}</Text>
      <Divider />
      <FormProvider {...formMethods}>
        <SectionGrid w="full" mt="24px">
          <TextField
            name="userFirstName"
            label={t('businessSignUp.form.userFirstName.label')}
            placeholder={t('businessSignUp.form.userFirstName.placeholder')}
            rhfOptions={{ required: true }}
            errorMessageFormatter={t}
          />
          <TextField
            name="userLastName"
            label={t('businessSignUp.form.userLastName.label')}
            placeholder={t('businessSignUp.form.userLastName.placeholder')}
            rhfOptions={{ required: true }}
            errorMessageFormatter={t}
          />
          <TextField
            name="userFiscalId"
            label={t('businessSignUp.form.userFiscalId.label')}
            placeholder={t('businessSignUp.form.userFiscalId.placeholder')}
            rhfOptions={{ required: true }}
            errorMessageFormatter={t}
            type="number"
          />
          <TextField
            name="userPhone"
            label={t('businessSignUp.form.userPhone.label')}
            placeholder={t('businessSignUp.form.userPhone.placeholder')}
            rhfOptions={{ required: true }}
            errorMessageFormatter={t}
            type="number"
          />
          <TextField
            name="userEmail"
            label={t('businessSignUp.form.userEmail.label')}
            placeholder={t('businessSignUp.form.userEmail.placeholder')}
            rhfOptions={{
              required: true,
            }}
            errorMessageFormatter={t}
            type="email"
          />
          <TextField
            name="userEmailConfirm"
            label={t('businessSignUp.form.userEmailConfirm.label')}
            placeholder={t('businessSignUp.form.userEmail.placeholder')}
            rhfOptions={{ required: true }}
            errorMessageFormatter={t}
            type="email"
          />
        </SectionGrid>
      </FormProvider>
      <Flex w="full" justifyContent={'flex-end'} mt={9}>
        <Button type="submit" variant={'primary'}>
          {t('businessSignUp.form.next')}
        </Button>
      </Flex>
    </Flex>
  );
};
